"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Filter;
    }
});
const _common = require("@nestjs/common");
const _Model = /*#__PURE__*/ _interop_require_default(require("~/models/Model"));
const _Column = /*#__PURE__*/ _interop_require_default(require("~/models/Column"));
const _View = /*#__PURE__*/ _interop_require_default(require("~/models/View"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _globals = require("~/utils/globals");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _extractProps = require("~/helpers/extractProps");
const _ncError = require("~/helpers/ncError");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const logger = new _common.Logger('Filter');
let Filter = class Filter {
    async getModel(context, ncMeta = _Noco.default.ncMeta) {
        return this.fk_view_id ? (await _View.default.get(context, this.fk_view_id, ncMeta)).getModel(context, ncMeta) : _Model.default.getByIdOrName(context, {
            id: this.fk_model_id
        }, ncMeta);
    }
    static async insert(context, filter, ncMeta = _Noco.default.ncMeta) {
        var _filter_children;
        const insertObj = (0, _extractProps.extractProps)(filter, [
            'id',
            'fk_view_id',
            'fk_column_id',
            'comparison_op',
            'value',
            'fk_parent_id',
            'is_group',
            'logical_op',
            'base_id',
            'source_id'
        ]);
        const model = await _Column.default.get(context, {
            colId: filter.fk_column_id
        }, ncMeta);
        if (!filter.source_id) {
            insertObj.source_id = model.source_id;
        }
        const row = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, insertObj);
        if (filter == null ? void 0 : (_filter_children = filter.children) == null ? void 0 : _filter_children.length) {
            await Promise.all(filter.children.map((f)=>this.insert(context, _extends({}, f, {
                    fk_parent_id: row.id
                }), ncMeta)));
        }
        return await this.redisPostInsert(context, row.id, filter, ncMeta);
    }
    static async redisPostInsert(context, id, filter, ncMeta = _Noco.default.ncMeta) {
        if (!(id && filter.fk_view_id)) {
            logger.error(`Mandatory fields missing in FILTER_EXP cache population : id(${id}), fk_view_id(${filter.fk_view_id}), fk_parent_id(${filter.fk_view_id})`);
            _ncError.NcError.get(context).internalServerError(`Failed to create filter`);
        }
        const key = `${_globals.CacheScope.FILTER_EXP}:${id}`;
        let value = await _NocoCache.default.get(context, key, _globals.CacheGetType.TYPE_OBJECT);
        if (!value) {
            /* get from db */ value = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, id);
            /* store in redis */ await _NocoCache.default.set(context, key, value).then(async ()=>{
                /* append key to relevant lists */ const p = [];
                p.push(_NocoCache.default.appendToList(context, _globals.CacheScope.FILTER_EXP, [
                    _globals.FilterCacheScope.VIEW,
                    filter.fk_view_id
                ], key));
                if (filter.fk_parent_id) {
                    p.push(_NocoCache.default.appendToList(context, _globals.CacheScope.FILTER_EXP, [
                        _globals.FilterCacheScope.VIEW,
                        filter.fk_view_id,
                        filter.fk_parent_id
                    ], key));
                    p.push(_NocoCache.default.appendToList(context, _globals.CacheScope.FILTER_EXP, [
                        _globals.FilterCacheScope.PARENT,
                        filter.fk_parent_id
                    ], key));
                }
                if (filter.fk_column_id) {
                    p.push(_NocoCache.default.appendToList(context, _globals.CacheScope.FILTER_EXP, [
                        _globals.FilterCacheScope.COLUMN,
                        filter.fk_column_id
                    ], key));
                }
                await Promise.all(p);
            });
        }
        return new Filter(value);
    }
    static async update(context, id, filter, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(filter, [
            'fk_column_id',
            'comparison_op',
            'value',
            'fk_parent_id',
            'is_group',
            'logical_op'
        ]);
        // set meta
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, updateObj, id);
        // update cache
        await _NocoCache.default.update(context, `${_globals.CacheScope.FILTER_EXP}:${id}`, updateObj);
    }
    static async delete(context, id, ncMeta = _Noco.default.ncMeta) {
        const filter = await this.get(context, id, ncMeta);
        const deleteRecursively = async (filter)=>{
            if (!filter) return;
            for (const f of await (filter == null ? void 0 : filter.getChildren(context, ncMeta)) || [])await deleteRecursively(f);
            await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, filter.id);
            await _NocoCache.default.deepDel(context, `${_globals.CacheScope.FILTER_EXP}:${filter.id}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
        };
        await deleteRecursively(filter);
    }
    getColumn(context, ncMeta = _Noco.default.ncMeta) {
        if (!this.fk_column_id) return null;
        return _Column.default.get(context, {
            colId: this.fk_column_id
        }, ncMeta);
    }
    // public async getGroup(ncMeta = Noco.ncMeta): Promise<Filter> {
    //   if (!this.fk_parent_id) return null;
    //   let filterObj = await NocoCache.get(
    //     `${CacheScope.FILTER_EXP}:${this.fk_parent_id}`,
    //     2
    //   );
    //   if (!filterObj) {
    //     filterObj = await ncMeta.metaGet2(context.workspace_id, context.base_id, MetaTable.FILTER_EXP, {
    //       id: this.fk_parent_id
    //     });
    //     await NocoCache.set(
    //       `${CacheScope.FILTER_EXP}:${this.fk_parent_id}`,
    //       filterObj
    //     );
    //   }
    //   return filterObj && new Filter(filterObj);
    // }
    //
    async getChildren(context, ncMeta = _Noco.default.ncMeta) {
        if (this.children) return this.children;
        if (!this.is_group) return null;
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.FILTER_EXP, [
            _globals.FilterCacheScope.PARENT,
            this.id
        ], {
            key: 'order'
        });
        let { list: childFilters } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !childFilters.length) {
            childFilters = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
                condition: {
                    fk_parent_id: this.id
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.FILTER_EXP, [
                _globals.FilterCacheScope.PARENT,
                this.id
            ], childFilters);
        }
        return childFilters && childFilters.map((f)=>new Filter(f));
    }
    // public static async getFilter({
    //   viewId
    // }: {
    //   viewId: string;
    // }): Promise<Filter> {
    //   if (!viewId) return null;
    //
    //   const filterObj = await ncMeta.metaGet2(
    // context.workspace_id,
    // context.base_id,
    //     MetaTable.FILTER_EXP,
    //     { fk_view_id: viewId, fk_parent_id: null }
    //   );
    //   return filterObj && new Filter(filterObj);
    // }
    static async getFilterObject(context, { viewId }, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.FILTER_EXP, [
            _globals.FilterCacheScope.VIEW,
            viewId
        ], {
            key: 'order'
        });
        let { list: filters } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !filters.length) {
            filters = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
                condition: {
                    fk_view_id: viewId
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.FILTER_EXP, [
                _globals.FilterCacheScope.VIEW,
                viewId
            ], filters);
        }
        const result = {
            is_group: true,
            children: [],
            logical_op: 'and'
        };
        /**
     * NOTE:
     * Earlier implementation relied on filter creation order when attaching children.
     * Now that filters support reordering, creation order is no longer reliable.
     *
     * This caused flattened filters to appear in the wrong sequence, leading to
     * incorrect parent–child relationships during import / duplicate base flows.
     *
     * The new approach explicitly groups by `fk_parent_id`, sorts by `order`,
     * and flattens the tree deterministically to preserve correct hierarchy.
     */ // parentId -> children
        const childrenMap = new Map();
        // 1️⃣ Group by fk_parent_id
        for (const filter of filters){
            var _filter_fk_parent_id;
            const parentId = (_filter_fk_parent_id = filter.fk_parent_id) != null ? _filter_fk_parent_id : 'root';
            if (!childrenMap.has(parentId)) {
                childrenMap.set(parentId, []);
            }
            childrenMap.get(parentId).push(filter);
        }
        // 2️⃣ Sort siblings by order
        for (const [, list] of childrenMap){
            list.sort((a, b)=>{
                var _a_order, _b_order;
                return ((_a_order = a.order) != null ? _a_order : Infinity) - ((_b_order = b.order) != null ? _b_order : Infinity);
            });
        }
        // 3️⃣ DFS → FLAT push (parent first, then children)
        const flat = [];
        const walk = (parentId)=>{
            const children = childrenMap.get(parentId);
            if (!children) return;
            for (const child of children){
                flat.push(child);
                walk(child.id);
            }
        };
        walk('root');
        // 4️⃣ Assign flat ordered result
        result.children = flat;
        // if (!result) {
        //   return (await Filter.insert({
        //     fk_view_id: viewId,
        //     is_group: true,
        //     logical_op: 'AND'
        //   })) as any;
        // }
        return result;
    }
    // static async deleteAll(viewId: string, ncMeta = Noco.ncMeta) {
    //   const filter = await this.getFilterObject({ viewId }, ncMeta);
    //
    //   const deleteRecursively = async filter => {
    //     if (!filter) return;
    //     for (const f of filter?.children || []) await deleteRecursively(f);
    //     if (filter.id) {
    //       await ncMeta.metaDelete(context.workspace_id, context.base_id, filter.id);
    //       await NocoCache.deepDel(
    //         `${CacheScope.FILTER_EXP}:${filter.id}`,
    //         CacheDelDirection.CHILD_TO_PARENT
    //       );
    //     }
    //   };
    //   await deleteRecursively(filter);
    // }
    //
    static async get(context, id, ncMeta = _Noco.default.ncMeta) {
        let filterObj = id && await _NocoCache.default.get(context, `${_globals.CacheScope.FILTER_EXP}:${id}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!filterObj) {
            filterObj = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
                id
            });
            await _NocoCache.default.set(context, `${_globals.CacheScope.FILTER_EXP}:${id}`, filterObj);
        }
        return filterObj && new Filter(filterObj);
    }
    //
    static async rootFilterList(context, { viewId }, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.FILTER_EXP, [
            _globals.FilterCacheScope.VIEW,
            viewId
        ], {
            key: 'order'
        });
        let { list: filterObjs } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !filterObjs.length) {
            filterObjs = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
                condition: {
                    fk_view_id: viewId
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.FILTER_EXP, [
                _globals.FilterCacheScope.VIEW,
                viewId
            ], filterObjs);
        }
        return filterObjs == null ? void 0 : filterObjs.map((f)=>new Filter(f));
    }
    constructor(data){
        Object.assign(this, data);
    }
};
